import { createPaginator } from "@smithy/core";
import { GetFaceSearchCommand, } from "../commands/GetFaceSearchCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetFaceSearch = createPaginator(RekognitionClient, GetFaceSearchCommand, "NextToken", "NextToken", "MaxResults");
